module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitleAddDevice[_vm.actualLanguage]))]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitleSticker[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldModuleId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel.deviceId),
      expression: "deviceModel.deviceId"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceModel.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceModel, "deviceId", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.displayKey) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "manufacturier"
    }
  }, [_vm._v(_vm._s(_vm.labelFieldModuleKey[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceModel.deviceKey),
      expression: "deviceModel.deviceKey"
    }],
    attrs: {
      "disabled": _vm.savingCar,
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceModel.deviceKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceModel, "deviceKey", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('hr', {
    attrs: {
      "size": "50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "font-w200 push-10"
  }, [_vm._v(_vm._s(_vm.displayMessage))])])]), _vm._v(" "), (_vm.deviceModel.deviceKey) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.deviceModel.deviceKey) ? _c('button', {
    staticClass: "btn btn-success btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.testKey
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonCheck[_vm.actualLanguage]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.codeConfirmed) ? _c('button', {
    staticClass: "btn btn-success btn-save",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.saveDevice
    }
  }, [_vm._v(_vm._s(_vm.labelFieldButtonAdd[_vm.actualLanguage]))]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6c00e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/AddDeviceForm.vue
// module id = 1504
// module chunks = 4